module.exports = require('./lib/main'); // eslint-disable-line import/no-unresolved, import/extensions
